import type { AssistantMode } from '@/stores/use-ui-store';

/**
 * Reconcile a `fullTab` assistant mode against whether its conversation tab is
 * still open. When the assistant tab is closed by any means (tab X, ⌘W,
 * programmatic), the mode would otherwise stay stuck at `fullTab` with no tab
 * to render — so fall back to the floating bar (`collapsed`), mirroring the
 * ⌘J reset. Other modes are left untouched (they own their own lifecycle).
 */
export function reconcileFullTabMode(
  mode: AssistantMode,
  hasConversationTab: boolean,
): AssistantMode {
  if (mode === 'fullTab' && !hasConversationTab) return 'collapsed';
  return mode;
}
